import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=618523aa&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618523aa')) {
      api.createRecord('618523aa', component.options)
    } else {
      api.reload('618523aa', component.options)
    }
    module.hot.accept("./Certificate.vue?vue&type=template&id=618523aa&", function () {
      api.rerender('618523aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/Certificate.vue"
export default component.exports